import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import './style.css';
import useReRouteHook from '../../assets/hooks/useReRouteHook';
import { getSearch } from '../../services/api/Api';
import JainamLoader, { loaderMessages } from '../common/JainamLoader/JainamLoader';
const SearchList = () => {
	const { searchTerm } = useParams();
	const [searchData, setSearchData] = useState([]);
	const [loading, setLoading] = useState(true);
	const { reRouteButtonRenderer } = useReRouteHook();

	useEffect(() => {
		const fetchSearchData = async () => {
			setLoading(true);
			try {
				const data = await getSearch(`search_str=${encodeURIComponent(searchTerm || '')}`);
				if (data && data.data.length > 0) {
					setSearchData(data.data);
				} else {
					setSearchData([]);
					console.error('Invalid API response format:', data);
				}
			} catch (error) {
				console.error('Error fetching CMS content:', error);
			} finally {
				setLoading(false);
			}
		};

		fetchSearchData();
	}, [searchTerm]);
	return (
		<>
			<section>
				<div className="container">
					<div className="row ">
						<div className="col my-lg-5">
							<div className="row">
								<div className="col-lg-11 mx-auto px-4 px-md-5 px-lg-2">
									{loading ? (
										<JainamLoader variant="page" messages={loaderMessages.search} />
									) : (
										<>
											<nav aria-label="breadcrumb ">
												<ol className="breadcrumb mt-3 mt-lg-0 cursor-pointer global-font">
													<li className="breadcrumb-item active" aria-current="page">
														<a href="/" className="color1 in_reg lh-24 me-1">
															Home
														</a>
													</li>
													<li className="breadcrumb-item">
														<a href="/" className="color1 in_reg lh-24 ms-1">
															{searchTerm}
														</a>
													</li>
												</ol>
											</nav>
											<h4 className="fs-24 py-3 in_semi search-head">
												Results for the keyword "{searchTerm}"
											</h4>
											<ul className="px-0">
												{searchData.map((item: any) => {
													const cmsCategory = item.cms_category.toLowerCase().replace(/\s+/g, '-');
													const parentCategory = item.parent_map[0]
														.toLowerCase()
														.replace(/\s+/g, '-');
													const MainCategory = item.parent_map[1]
														.toLowerCase()
														.replace(/\s+/g, '-');
													return (
														<li
															className="mb-2 fs-16 search-list  list-unstyled in_med lh-24"
															style={{ padding: '10px 0' }}
															key={item.title}>
															{reRouteButtonRenderer({
																url: `/category/${encodeURIComponent(
																	MainCategory,
																)}/${encodeURIComponent(parentCategory)}/${encodeURIComponent(
																	cmsCategory,
																)}/${encodeURIComponent(item.id)}`,
																classes: 'color1 p-0',
																nameText: item.title.trim(),
															})}
														</li>
													);
												})}
											</ul>
										</>
									)}
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
		</>
	);
};

export default SearchList;
